import { Info } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Badge } from "~/components/ui/badge";
import { Text } from "~/components/text";

export const NotIncludedInExportBadge = () => {
  const { t } = useTranslation(["components"]);

  return (
    <Badge
      variant="secondary"
      className="h-[max-content] flex gap-x-[6px] px-[10px] py-1"
      data-testid="not-included-in-export-badge"
    >
      <Info className="size-3 text-secondary-800" />
      <Text as="span" variant="labelSmall">
        {t("components:notIncludedInExportBadge.label")}
      </Text>
    </Badge>
  );
};
